import clienteAxios from "../config/axios";

export async function deleteAndGetPagosByNroCtaFromSoftland (nroCta) {
    return clienteAxios.get(`/deleteAndGet/pagosByNroCtaFromSoftland/nroCta/${nroCta}`);
}

export async function getPagosByNroCta (nroCta) {
    return clienteAxios.get(`/pagos/nroCta/${nroCta}`);
}

export async function getPagosNotAnnulledByNroCta (nroCta) {
    return clienteAxios.get(`/pagosNotAnnulled/nroCta/${nroCta}`);
}

export async function createPDFOp(codFor ,nroFor) {
  return clienteAxios.post("/pago/informe", { codFor, nroFor});
}